import {
    Component, Inject, OnDestroy, OnInit, ChangeDetectorRef
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { take, delay } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { LayoutConfigService } from '../../../../core/_base/layout';
import { LayoutUtilsService } from '../../../../core/_base/crud';
import { AppState } from '../../../../core/reducers';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import {
    AuditTrailReportService,
    AllAuditTrailReportsRequested,
    selectAllAuditTrailReports,
    AuditTrailReport,
    AuditTrailReportOnServerCreated,
    selectLastCreatedAuditTrailReportId
} from '../../../../core/assignment';
import { currentUser, User } from 'src/app/core/mad-auth/mad-auth.store';
import { ToeExcludeDialogComponent } from '../../assignment/audit/_sub/toe-exclude-dialog/toe-exclude-dialog.component';
// import { ToeExcludeDialogComponent } from '../../apps/assignment/audit/_sub/toe-exclude-dialog/toe-exclude-dialog.component';

@Component({
    selector: 'kt-audit-report-dialog',
    templateUrl: './audit-report-dialog.component.html',
    styleUrls: ['./audit-report-dialog.component.scss'],
})
export class AuditReportDialogComponent implements OnInit, OnDestroy {

    form: UntypedFormGroup;
    currentUser: User;
    generatedReports: any[] = [];
    generating: boolean;

    displayedColumnsGeneratedReport = ['created_at', 'file_size', 'including_not_signed', 'status', 'actions'];
    dataSourceGeneratedReport = new MatTableDataSource();

    private subscriptions: Subscription[] = [];

    /**
     * Component constructor
     *
     * @param dialogRef
     * @param data
     * @param fb: FormBuilder
     * @param store
     */
    constructor(public dialogRef: MatDialogRef<AuditReportDialogComponent>,
                private dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private fb: UntypedFormBuilder,
                private store: Store<AppState>,
                private ref: ChangeDetectorRef,
                private layoutConfigService: LayoutConfigService,
                private layoutUtilsService: LayoutUtilsService,
                private auditTrailReportService: AuditTrailReportService,
                private translate: TranslateService) {

    }

    ngOnInit() {
        this.generating = false;

        const userSubscription = this.store.pipe(
            select(currentUser))
            .subscribe(res => {
                if (res) {
                    this.currentUser = res;
                }
            });
        this.subscriptions.push(userSubscription);
        
        this.store.dispatch(new AllAuditTrailReportsRequested({assignmentId: this.data.assId}));
        
        const auditTrailReportSubscription = this.store.pipe(
            select(selectAllAuditTrailReports),
        ).subscribe((res) => {
            this.generating = false;
            this.generatedReports = res.sort((a, b) =>
                (a.id < b.id) ? 1
                    : (b.id < a.id) ? -1 : 0);
            this.dataSourceGeneratedReport = new MatTableDataSource(this.generatedReports);
            // this.ref.markForCheck();
            // this.ref.detectChanges();
        });
        
        this.subscriptions.push(auditTrailReportSubscription);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(_subscription => {
            _subscription.unsubscribe();
        });
    }

    onClickClose(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        const dialogRef = this.dialog.open(ToeExcludeDialogComponent, {
            width: '440px'
        });
        dialogRef.afterClosed().subscribe(res => {
            const onlySigned = res;
        
            const _auditTrailReport = new AuditTrailReport();
            _auditTrailReport.clear();
            _auditTrailReport.assignment_id = this.data.assId;
            _auditTrailReport.status = 0; // 0 means in progress
            _auditTrailReport.user_id = this.currentUser.id;
            _auditTrailReport.includesOnlySignedToe = onlySigned;
        
            setInterval(() => {
                this.generating = this.layoutConfigService.getGeneratingLayout() == '1';
            }, 1000);
            this.generating = true;
            this.layoutConfigService.showGeneratingLayout();
        
            this.store.dispatch(new AuditTrailReportOnServerCreated({
                auditTrailReport: _auditTrailReport
            }));
        
            const auditTrailReportSubscriptions = this.store.pipe(
                select(selectLastCreatedAuditTrailReportId),
                delay(1000), // Remove this line
            ).subscribe(res => {
                if (!res) {
                    return;
                }
                this.auditTrailReportService.generateAuditTrailReport(this.data.assId, this.currentUser.id, res, onlySigned).subscribe(res => {
                    if (res) {
                        this.store.dispatch(new AllAuditTrailReportsRequested({assignmentId: this.data.assId}));
                        this.layoutConfigService.hideGeneratingLayout();
                    }
                });
            });
        
            this.subscriptions.push(auditTrailReportSubscriptions);
        })
        
        
    }

    isFormValid() {
        return true;
    }

    downloadAuditTrailReport(item, index) {
        window.open(item.url, '_blank');
    }

    deleteAuditTrailReport(item, index) {
        const _title = 'Are you sure?';
        const _description = 'The report history data will be lost';
        const _waitDesciption = 'Report history deleting';

        const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
        dialogRef.afterClosed().subscribe(res => {
            if (!res) {
                return;
            }

            this.auditTrailReportService.deleteAuditTrailReport(item.id).subscribe(res => {
                const tempGeneratedReports = [...this.generatedReports];
                tempGeneratedReports.splice(index, 1);
                this.generatedReports = tempGeneratedReports;
                this.dataSourceGeneratedReport = new MatTableDataSource(this.generatedReports);
            });
        });
    }

    /**
     * Returns Item Status in string
     * @param status: number
     */
    getItemStatusString(status: number = 0): string {
        switch (status) {
            case 0:
                return 'Draft';
            case 1:
                return 'Validated';
            case 2:
                return 'Signed';
            case 3:
                return 'Completed';
            case 4:
                return 'Aborted';
        }
        return '';
    }

    /** UI */
    /**
     * Retursn CSS Class Name by status
     *
     * @param status: number
     */
    getItemCssClassByStatus(status: number = 0): string {
        switch (status) {
            case 0:
                return 'metal';
            case 4:
                return 'danger';

            default:
                return 'success';
        }
    }
}
